module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_3.c9b6ef17.pdf";